<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Route Stop Report</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
              @change="getRouteStopReport()"
            />
          </v-col>
        </v-row>
      </v-card>
      <v-card class="box" v-if="this.show_table == true">
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong> Transport Fees Report </strong>
          </v-toolbar-title> </v-toolbar
        ><br />
        <v-row dense>
          <!-- <v-col cols="12" sm="6" md="6">
            <v-btn rounded color="success" outlined @click="ExportToExcel()"
              ><v-icon color="success">mdi-export</v-icon>Export</v-btn
            >
          </v-col> -->
          <v-col
            cols="12"
            sm="3"
            md="3"
            v-if="transport_details_list.length != 0"
          >
            <v-btn color="success" outlined rounded>
              <download-excel
                class="mr-2 pb-3 pt-2"
                :data="bookList1"
                :fields="table_fields"
                worksheet="RouteStopReport"
                name="RouteStopReport.xls"
              >
                <v-icon dark>mdi-file-excel</v-icon> Export
              </download-excel>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="3" md="3"></v-col>
          <v-col cols="12" sm="6" md="6" justify="right">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense justify="center" align="center">
          <!-- <v-row> -->
          <span v-for="header in headers" :key="header.text">
            <span v-if="filters.hasOwnProperty(header.value)">
              <v-autocomplete
                class="mr-2 pb-5 pt-2"
                flat
                hide-details
                small
                rounded
                dense
                outlined
                color="#0F2027"
                :label="header.text"
                multiple
                clearable
                :items="columnValueList(header.value)"
                v-model="filters[header.value]"
              ></v-autocomplete>
            </span>
          </span>
          <!-- </v-row> -->
        </v-row>
        <!-- <br /> -->

        <!-- <div id="my-table-id">
          <v-simple-table
            class="elevation-1 mytable"
            fixed-header
            height="500px"
          >
            <template>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Route</th>
                  <th>Route Stop</th>
                  <th>Actial Disatance in KM</th>
                  <th>Fees</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in transport_details_list"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.route }}</td>
                  <td>{{ item.routestop }}</td>
                  <td>{{ item.distance }}</td>
                  <td>{{ item.amount }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div> -->

        <!-- data table by shiv -->
        <v-data-table
          :headers="headers"
          :items="bookList1"
          :search="search"
          class="elevation-1 mytable"
          dense
          v-if="transport_details_list != ''"
          @current-items="getFiltered"
        >
        </v-data-table>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ay_list: [],
    ay: "",
    standard_list: [],
    standard: "",
    show_table: false,
    transport_details_list: [],
    headers: [
      { text: "Route", value: "route" },
      { text: "Route Stop", value: "routestop" },
      { text: "Actual Disatance in KM", value: "distance" },
      { text: "Fees", value: "amount" },
    ],

    table_fields: {
      Route: "route",
      "Route Stop": "routestop",
      "Actual Disatance in KM": "distance",
      Fees: "amount",
    },
    search: "",
    filterArr: [],
    filters: {
      route: [],
      routestop: [],
    },
  }),
  computed: {
    filteredItems() {
      return this.transport_details_list.filter((item) => {
        return (
          item.route.toLowerCase().indexOf(this.search.toLowerCase()) > -1 ||
          item.routestop.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        );
      });
    },
    bookList1() {
      return this.transport_details_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
  methods: {
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      return this.transport_details_list.map((d) => d[val]);
    },
    getRouteStopReport() {
      this.overlay = true;
      const data = {
        ay: this.ay,
      };
      axios
        .post("ParentTransport/getRouteStopReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.show_table = true;
            this.transport_details_list = res.data.transport_details_list;
            this.overlay = false;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    ExportToExcel() {
      this.exs_loader = true;
      var htmltable = document.getElementById("my-table-id");
      var html = htmltable.outerHTML;
      window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
      this.exs_loader = false;
    },
    onLoad() {
      axios
        .post("ParentTransport/TransportFeesReport")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list),
              //(this.ay = res.data.curreny_ay);
              (this.overlay = false);
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  /* margin: 0.3rem !important; */
  /* padding: 0.4rem !important; */
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
</style>